import { render, staticRenderFns } from "./advertDetail.vue?vue&type=template&id=453361fd&scoped=true"
import script from "./advertDetail.vue?vue&type=script&lang=js"
export * from "./advertDetail.vue?vue&type=script&lang=js"
import style0 from "./advertDetail.vue?vue&type=style&index=0&id=453361fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453361fd",
  null
  
)

export default component.exports